import { NavLink } from "react-router-dom";
import { useEffect, useState } from "react";

export default function AsideV2() {
  const [currentOrigin, setCurrentOrigin] = useState(window.location.origin + "/admin");

  const websites = [
    { name: "Compre Imóveis", url: "https://www.compreimoveis.com/admin/v2/home", host: "www.compreimoveis.com" },
    { name: "Alugue Imóveis", url: "https://www.alugueimoveis.com/admin/v2/home", host: "www.alugueimoveis.com" },
  ];

  function handleWebsiteChange(e) {
    const selectedUrl = e.target.value;
    if (selectedUrl !== currentOrigin) {
      window.location.href = selectedUrl;
    }
  }

  return (
    <aside className="sidebar-nav-wrapper">
      <div className="navbar-logo">
        <a href="index.html">{/* logo aqui se necessário */}</a>
      </div>

      <nav className="sidebar-nav">
        <ul>
          <li className="nav-item nav-item-has-children">
            <a
              href="#0"
              data-bs-toggle="collapse"
              data-bs-target="#ddmenu_1"
              aria-controls="ddmenu_1"
              aria-expanded="false"
              aria-label="Toggle navigation"
              style={{ textDecoration: "none" }}
            >
              <span className="icon">{/* ícone SVG */}</span>
              <span className="text">Dashboard</span>
            </a>

            <ul id="ddmenu_1" className="collapse show dropdown-nav">
              <li><NavLink to="/admin/v2/home" style={{ textDecoration: "none" }}>Resumo Geral</NavLink></li>
              {/* <li><NavLink to={"/admin/v2/financeiro"} style={{ textDecoration: "none" }}>Financeiro</NavLink></li> */}
              <li><NavLink to="/admin/v2/users" style={{ textDecoration: "none" }}>Usuários</NavLink></li>
              <li><NavLink to="/admin/v2/blogs" style={{ textDecoration: "none" }}>Blogs</NavLink></li>
              <li><NavLink to="/admin/v2/properties" style={{ textDecoration: "none" }}>Imóveis</NavLink></li>
              <li><NavLink to="/admin/v2/reports" style={{ textDecoration: "none" }}>Flags</NavLink></li>
              <li><NavLink to="/admin/v2/plans" style={{ textDecoration: "none" }}>Planos</NavLink></li>
              <li><NavLink to="/admin/v2/configs" style={{ textDecoration: "none" }}>Configurações</NavLink></li>
            </ul>
          </li>

          <span className="divider"><hr /></span>

          <li className="nav-item p-3">
            <label htmlFor="site-switch" className="text-muted mb-2 d-block">Trocar site:</label>
            <select
              id="site-switch"
              className="form-select"
              onChange={handleWebsiteChange}
              value={currentOrigin}
            >
              {websites.map(site => (
                <option key={site.url} value={site.url}>
                  {site.name}
                </option>
              ))}
            </select>
          </li>

          <span className="divider"><hr /></span>

          <li>
            <ul>
              <li>
                <a href="/" target="_blank" style={{textDecoration: "none", color: "#9AA4CA"}}>Voltar para o site</a>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
    </aside>
  );
}
